var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tab-item",
    [
      _c(
        "v-layout",
        { attrs: { "justify-space-between": "" } },
        [
          _c(
            "v-flex",
            { attrs: { md2: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { dark: "", color: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showTemplateDialog()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                  _vm._v(_vm._s(_vm.$t("template")))
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md2: "" } },
            [
              _c("v-text-field", {
                staticClass: "text-xs-right",
                attrs: {
                  "append-icon": "filter_list",
                  label: _vm.$t("search"),
                  "single-line": "",
                  "hide-details": "",
                  clearable: ""
                },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "my-1 levation-2 myDense",
        attrs: {
          headers: _vm.templateHeaders,
          items: _vm.templates,
          "item-key": "key",
          "rows-per-page-items": _vm.rowPerPage,
          search: _vm.filter
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(props) {
              return [
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v("\n        " + _vm._s(props.item.name) + "\n      ")
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.from && props.item.from.fullName))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "text-xs-left",
                    staticStyle: {
                      "max-width": "30vw",
                      "word-break": "break-all"
                    }
                  },
                  [
                    _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                      _vm._v(
                        "\n          " + _vm._s(props.item.sku) + "\n        "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    props.item.note
                      ? _c("v-layout", { attrs: { wrap: "" } }, [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.$t("note")) + ":  ")
                          ]),
                          _vm._v(_vm._s(props.item.note) + "\n        ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { "justify-space-between": "" } },
                      [
                        _vm.packagingMap.has(props.item.packaging)
                          ? _c("v-flex", { attrs: { md6: "" } }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(_vm.$t("Size(L/W/H)")) + ": ")
                              ]),
                              _vm._v(
                                _vm._s(
                                  _vm.displayPackaging(
                                    _vm.packagingMap.get(props.item.packaging)
                                  )
                                ) + "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { md6: "" } }, [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.$t("weight")) + ": ")
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.displayWeight(props.item)) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-layout", { staticClass: "text-capitalize" }, [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("signature")) + ":  ")
                      ]),
                      _vm._v(" " + _vm._s(props.item.signature) + "\n        ")
                    ]),
                    _vm._v(" "),
                    props.item.memo
                      ? _c("v-layout", { attrs: { wrap: "" } }, [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.$t("memo")) + ":  ")
                          ]),
                          _vm._v(_vm._s(props.item.memo) + "\n        ")
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.shippingService))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(props.item.isExpedited ? "expedite" : "normal")
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  _vm._l(props.item.selectedOtherServices, function(item) {
                    return _c("v-chip", { key: item }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            (
                              _vm.otherServices.find(function(service) {
                                return (
                                  service.value.toLowerCase() ===
                                  item.toLowerCase()
                                )
                              }) || {}
                            ).displayName || item
                          ) +
                          "\n        "
                      )
                    ])
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { dark: "", flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.showTemplateDialog(props.item)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("edit")))]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { dark: "", flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.deleteTemplate(props.item)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.createTemplateDialog
        ? _c("LabelTemplatePopup", {
            attrs: { initTemplate: _vm.templateInEdit },
            model: {
              value: _vm.createTemplateDialog,
              callback: function($$v) {
                _vm.createTemplateDialog = $$v
              },
              expression: "createTemplateDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5640ca6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5640ca6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShippingTemplateTab.vue
// module id = null
// module chunks = 